import React, { createContext, useContext, useMemo } from 'react';
import { VictoryPointStateReader } from '@colonist/game-base-types';
import { RankedUserStateController } from '@colonist/leaderboard-types';
import { useGameStore } from '../store/GameStoreContext.ts';
export const UIGameEndContext = /*#__PURE__*/ createContext(undefined);
export const useUIGameEndContext = ()=>{
    const context = useContext(UIGameEndContext);
    if (!context) throw new Error('UIGameEndContext not found');
    return context;
};
export function UIGameEndProvider({ onClickRematch, onClickPlayAgain, onClickRetryBeginnerMode, onClickNextLevelBeginnerMode, onClickHome, onClickShare, onClickStatsOrReplay, onEndGameScreenOpen, onEndGameScreenClose, gameEndData, numberOfPlayersJoinedRematch, children }) {
    const myColor = useGameStore((state)=>state.myColor);
    const isMyColorWinner = useMemo(()=>{
        var _gameEndData_endGameState_players_myColor;
        return ((_gameEndData_endGameState_players_myColor = gameEndData.endGameState.players[myColor]) === null || _gameEndData_endGameState_players_myColor === void 0 ? void 0 : _gameEndData_endGameState_players_myColor.winningPlayer) === true;
    }, [
        gameEndData,
        myColor
    ]);
    const setShowEndGameScreen = (visible)=>{
        if (visible) onEndGameScreenOpen();
        else onEndGameScreenClose();
    };
    const playersByRank = useMemo(()=>Object.values(gameEndData.endGameState.players).sort((a, b)=>a.rank - b.rank).map((item)=>({
                ...item,
                totalVictoryPoints: VictoryPointStateReader.totalPrivateVictoryPoints(item.victoryPoints)
            })), [
        gameEndData
    ]);
    const currentPlayerEndgameState = gameEndData === null || gameEndData === void 0 ? void 0 : gameEndData.endGameState.players[myColor];
    const { currentPlayerRankedState, userRankedStatesByColor } = useMemo(()=>{
        var _gameEndData_rankedUserStates;
        const userRankedStatesByColorMap = {};
        gameEndData === null || gameEndData === void 0 ? void 0 : (_gameEndData_rankedUserStates = gameEndData.rankedUserStates) === null || _gameEndData_rankedUserStates === void 0 ? void 0 : _gameEndData_rankedUserStates.forEach((rankedUserState)=>{
            const deserializedRankedUserState = RankedUserStateController.deserialize(rankedUserState.rankedState);
            userRankedStatesByColorMap[rankedUserState.color] = deserializedRankedUserState;
        });
        return {
            currentPlayerRankedState: userRankedStatesByColorMap[myColor],
            userRankedStatesByColor: userRankedStatesByColorMap
        };
    }, [
        gameEndData,
        myColor
    ]);
    const isPlayerHasRankedState = Boolean(currentPlayerRankedState);
    return /*#__PURE__*/ React.createElement(UIGameEndContext.Provider, {
        value: {
            onClickRematch: onClickRematch,
            onClickPlayAgain: onClickPlayAgain,
            onClickRetryBeginnerMode: onClickRetryBeginnerMode,
            onClickNextLevelBeginnerMode: onClickNextLevelBeginnerMode,
            onClickHome: onClickHome,
            onClickShare: onClickShare,
            onClickStatsOrReplay: onClickStatsOrReplay,
            setShowEndGameScreen: setShowEndGameScreen,
            isMyColorWinner: isMyColorWinner,
            numberOfPlayersJoinedRematch: numberOfPlayersJoinedRematch,
            playersByRank: playersByRank,
            gameEndData: gameEndData,
            currentPlayerEndgameState: currentPlayerEndgameState,
            currentPlayerRankedState: currentPlayerRankedState,
            userRankedStatesByColor: userRankedStatesByColor,
            isPlayerHasRankedState: isPlayerHasRankedState
        }
    }, children);
}
